// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"210":"8c8362ef","990":"ea085a67"}[chunkId] + ".chunk.css";
};